// @flow
import React, { useState, useContext } from 'react';
import { Redirect, withRouter } from 'react-router-dom';

import Box from 'bizom-mui/lib/Box';

import { SessionContext } from 'session';
import { LOGIN, HOME } from 'constants/paths';
import OTPVerificationForm from './OTPVerificationForm';
import { toRawPhoneNumber } from 'utils/toRawPhoneNumber';
import { SnackbarContext } from 'contexts/SnackbarContext';
import { LocaleContext } from 'contexts/LocaleContext';
import { OTP_SENT, SOMETHING_WENT_WRONG } from 'constants/errors';

import type { LoginParams } from 'types/session.js.flow';

type Props = {
  resending: boolean,
  validating: boolean,
  history: any,
  onResendOTP: ({ phoneno: string, dialCode: string }) => Promise<any>,
  onValidateOTP: (LoginParams) => Promise<any>,
};

const Verify = ({
  resending,
  validating,
  history,
  onResendOTP,
  onValidateOTP,
}: Props) => {
  const { session } = useContext(SessionContext);
  const { openSnackbar } = useContext(SnackbarContext);
  const { setLocale, language } = useContext(LocaleContext);
  const [resendState, setResentState] = useState(
    JSON.parse(localStorage.getItem('resend-otp-state') || '{}')
  );

  const phoneno = localStorage.getItem('phoneno');
  const dialCode = localStorage.getItem('dialCode');

  if (!phoneno || !dialCode || (resendState && !resendState.ts)) {
    return <Redirect to={LOGIN} />;
  }

  if (session && session.token) {
    return <Redirect to={HOME} />;
  }

  const rawPhone = toRawPhoneNumber(phoneno, dialCode);
  const handleResendOTP = () => {
    onResendOTP({ phoneno: `${rawPhone}`, dialCode })
      .then((response) => {
        if (response && response.data.otpRequest.response) {
          const otpState = {
            count: resendState.count + 1,
            ts: new Date().getTime(),
          };
          localStorage.setItem('resend-otp-state', JSON.stringify(otpState));
          setResentState(otpState);
          openSnackbar &&
            openSnackbar({
              id: 'resend-otp-success',
              message: OTP_SENT,
              autoHide: true,
            });
        }
      })
      .catch((err) => {
        openSnackbar &&
          openSnackbar({
            id: 'resend-otp-error',
            message: SOMETHING_WENT_WRONG,
            autoHide: true,
          });
      });
  };

  const handleValidateOTP = async (otp: string) => {
    await onValidateOTP({ otp, phoneno: rawPhone, dialCode });
    setLocale(language);
  };

  return (
    <Box p={3} pt={9}>
      <OTPVerificationForm
        phoneno={phoneno}
        resending={resending}
        validating={validating}
        resendState={resendState}
        onResend={handleResendOTP}
        onSubmit={handleValidateOTP}
      />
    </Box>
  );
};

export default withRouter(Verify);
